import { FC, useState } from 'react';
import GoalMetDialog from './GoalMetDialog';
import { WeeklySnapshotQueryFilters } from '../WeeklySnapshot';
import { useQueryLoader } from 'react-relay';
import { DashboardGoalMetPassedOrNotQuery } from '../../../graphQLOperations/__generated__/DashboardGoalMetPassedOrNotQuery.graphql';
import { WeeklyPaceSkillSource } from '../../../graphQLOperations/__generated__/DashboardGetWeeklySnapshotQuery.graphql';
import { getGoalMetPassedOrNot } from '../../../graphQLOperations/Dashboard';

interface Props {
  studentsMetGoal: number;
  totalStudents: number;
  queryFilters: WeeklySnapshotQueryFilters;
  source: WeeklyPaceSkillSource;
}

const GoalMet: FC<Props> = ({ studentsMetGoal, totalStudents, queryFilters, source }) => {
  const [goalMetDialogVisible, setGoalMetDialogVisible] = useState<boolean>(false);
  const [queryReferenceTrue, loadQueryTrue] = useQueryLoader<DashboardGoalMetPassedOrNotQuery>(getGoalMetPassedOrNot);
  const [queryReferenceFalse, loadQueryFalse] = useQueryLoader<DashboardGoalMetPassedOrNotQuery>(getGoalMetPassedOrNot);

  const percentage = totalStudents ? Math.round((studentsMetGoal / totalStudents) * 100) : 0;

  const loadQueryHandler = () => {
    // targetGroupIds is part of the filter the snapshot bars use, so it has to travel with these
    // lists too — otherwise the dialog reports on a wider set of students than the counter does.
    const filter = {
      classIds: queryFilters.classIds,
      siteIds: queryFilters.siteIds,
      gradeLevelIds: queryFilters.gradeLevelIds,
      targetGroupIds: queryFilters.targetGroupIds,
      reportFromDate: queryFilters.reportFromDate,
      reportToDate: queryFilters.reportToDate,
    };

    loadQueryTrue({ filter, returnMeetOrPassedSkillGoal: true, source });
    loadQueryFalse({ filter, returnMeetOrPassedSkillGoal: false, source });
    setGoalMetDialogVisible(true);
  };

  return (
    <>
      <button
        id="GoalMetWeekly"
        type="button"
        onClick={loadQueryHandler}
        aria-label={`${studentsMetGoal} of ${totalStudents} students met the goal. View students.`}
        className="tw-flex tw-cursor-pointer tw-items-baseline tw-gap-1 tw-border-none tw-bg-transparent tw-p-0"
      >
        <span className="tw-font-sora tw-text-2xl tw-font-bold tw-text-neutral-950">{studentsMetGoal}</span>
        <span className="tw-font-atkinson tw-text-base tw-text-neutral-700">/{totalStudents} met the goal</span>
      </button>
      {goalMetDialogVisible && (
        <GoalMetDialog
          visible={goalMetDialogVisible}
          setVisible={setGoalMetDialogVisible}
          percentage={percentage}
          queryReferenceTrue={queryReferenceTrue}
          queryReferenceFalse={queryReferenceFalse}
        />
      )}
    </>
  );
};

export default GoalMet;
